import $ from "jquery";
import Splide from "@splidejs/splide";

$(function () {
	document.querySelectorAll(".aka-block-cards-image .splide").forEach((el) => {
		const splide = new Splide(el, {
			type: "loop",
			arrows: false,
			pagination: false,
			autoWidth: false,
			gap: "1rem",
			mediaQuery: "min",
			perPage: 1,
			padding: { left: "1rem", right: "35%" }, // mobile: show 1.5 slides
			breakpoints: {
				576: {
					perPage: 2, // show 2 full slides
					padding: { left: "1rem", right: "25%" }, // reveal half of the 3rd
				},
				1280: {
					destroy: true,
				},
			},
		});

		splide.mount();
	});
});
